import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { Service, Languages } from '../../models/enums.model';
import { Listing } from '../../models/listing.model';
import { EtenderService } from '../../services/etender.service';
import { GlobalServices } from '../../services/global.service';
import { MyTasksService } from '../../services/my-Tasks.service';
import { GridViewComponent } from '../grid-view/grid-view.component';

@Component({
  selector: 'app-ebooking-tasks',
  templateUrl: './ebooking-tasks.component.html'
})
export class EbookingTasksComponent {
  collection: Listing;
  pageSize = 15;
  itemsMenu: MenuItem[] = [];
  gridName = '';
  EbookingServices = [Service.FeesEstimation, Service.TransitRequest, Service.AgentRegisteration, Service.UpdateAgentProfile];
  @ViewChild('EbookingTasks', { static: false }) gridView: GridViewComponent;
  public currentUser: User = new User();
  userGroups: any;
  constructor(private myTasksService: MyTasksService, private route: ActivatedRoute, private global: GlobalServices,
    private authenticationService: AuthenticationService, private router: Router, private etenderSrv: EtenderService) {
    this.currentUser = this.authenticationService.currentUserValue;

    this.etenderSrv.GetUserGroups(this.authenticationService.currentUserValue.Email).subscribe(
      data => {
        this.userGroups = data.Data;

      });
  }

  ngOnInit() {
    this.initiateMyTasks();
  }

  loadMyTasks(pPageIndex: number, pPrimarySortBy: string, pPrimarySortDirection: string, pSecondarySortBy: string, pSecondarySortDirection: string) {
    this.myTasksService.GetPendingTasksByServices(this.EbookingServices, this.currentUser.UserName, pPageIndex, this.pageSize, pPrimarySortBy, pPrimarySortDirection,
      pSecondarySortBy, pSecondarySortDirection).subscribe(
        // this.myTasksService.getPendingTasks("nashwa.mostafa@linkdev.com", pPageIndex, this.pageSize, pSortBy, pSortDirection).subscribe(
        data => this.collection = data.Data,
        () => console.log('Something went wrong!!'),
        () => this.loadCollectionCompleted(pPrimarySortBy, pPrimarySortDirection, pSecondarySortBy, pSecondarySortDirection)
      );
  }

  loadCollectionCompleted(pPrimarySortBy: string, pPrimarySortDirection: string, pSecondarySortBy: string, pSecondarySortDirection: string) {
    this.loadItemsMenu();
    this.gridName = this.collection.Collection.filter(e => this.EbookingServices
      .find(a => a == e['ServiceId'])).length > 0 ? 'SHARED.EBOOKING_TASKS' : 'SHARED.MYTASKS';

    this.gridView.loadGrid(this.collection, this.collection == null ? 0 : this.collection.TotalNumber, this.pageSize,
      'Tasks/GetPendingTasksByService?Services=' + this.EbookingServices +
      '&userName=' + this.currentUser.UserName +
      '&pageIndex={PAGEINDEX}&pageSize=' + this.pageSize +
      '&primSortBy={SORTBY1}&primSortDirection={SORTDIR1}' +
      '&secSortBy={SORTBY2}&secSortDirection={SORTDIR2}' +
      '&lang=' + (this.global.getLanguage() == Languages.Arabic ? 'Ar' : 'En'),
      this.gridName, this.itemsMenu, pPrimarySortBy, pPrimarySortDirection, pSecondarySortBy, pSecondarySortDirection, 'EbookingTasks');

    this.global.isLoaderEnabled = false;
  }

  loadItemsMenu() {
    this.itemsMenu[0] = new MenuItem();
    this.itemsMenu[0].Title = 'Details';
    this.itemsMenu[0].TitleAr = 'التفاصيل';
    this.itemsMenu[1] = new MenuItem();
    this.itemsMenu[1].Title = 'Request History';
    this.itemsMenu[1].TitleAr = 'تاريخ الطلب';
    if (this.currentUser.IsAdmin) {
      this.itemsMenu[2] = new MenuItem();
      this.itemsMenu[2].Title = 'Workflow Status';
      this.itemsMenu[2].TitleAr = 'حالة مسار العمل';
    }
  }
  resetOrder() {
    this.global.myTasksSortsndPagingCriteria = [];
    this.global.isLoaderEnabled = true;
    this.loadMyTasks(0, 'ModificationDate', 'DESC', 'ModificationDate', 'DESC');
  }

  initiateMyTasks() {
    this.global.isLoaderEnabled = true;
    if (this.global.myTasksSortsndPagingCriteria.length > 0) {
      this.loadMyTasks(this.global.myTasksSortsndPagingCriteria[0].currentPage - 1,
        this.global.myTasksSortsndPagingCriteria[0].sortingColumns[1][0], this.global.myTasksSortsndPagingCriteria[0].sortingColumns[1][1],
        this.global.myTasksSortsndPagingCriteria[0].sortingColumns[0][0], this.global.myTasksSortsndPagingCriteria[0].sortingColumns[0][1]);
    }
    else {
      this.loadMyTasks(0, 'ModificationDate', 'DESC', 'ModificationDate', 'DESC');
    }
  }
}

export class MenuItem {
  Title: string;
  TitleAr: string;
}
